import { render, staticRenderFns } from "./BrowserNotifications.vue?vue&type=template&id=ff468ee4&"
import script from "./BrowserNotifications.vue?vue&type=script&lang=js&"
export * from "./BrowserNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports